export default __webpack_public_path__ + "static/media/swipe.47e75b87.png";